import Introduction from './sections/Introduction';
import './Main.css';
import Portfolio from './sections/Portfolio/Portfolio';
import About from './sections/About';
import Contact from './sections/Contact';

const Main = () => (
  <>
    <Introduction />
    <Portfolio />
    <About />
    <Contact />
  </>
);

export default Main;
